import $ from 'jquery'

class Search {
    constructor() {
        this.addSearchOverlay()
        this.searchResults = $("#search-results")
        //this.searchMenuItem = $("#menu-hauptnavigation")
        //this.searchMenuItem.append('<li><a href="#" class="js-search-trigger"><i class="fa fa-search"></i></a></li>')
        this.openButton = $(".js-search-trigger")
        this.closeButton = $(".js-search-close")
        this.searchOverlay = $(".search-overlay")
        this.searchBox = $("#search-term")
        this.searchIsOpen = false;
        this.typingTimer;
        this.spinning = false;
        this.prevSearchTerm;

        this.events()
    }

    // Events
    events() {
        this.openButton.on("click", this.openOverlay.bind(this))
        this.closeButton.on("click", this.closeOverlay.bind(this))
        $(document).on("keydown", this.keyupDispatcher.bind(this))
        this.searchBox.on("keyup", this.typingLogic.bind(this))
    }

    // Actions
    typingLogic(e) {
        if (this.searchBox.val() != this.prevSeachTerm) {
            clearTimeout(this.typingTimer)
            if (this.searchBox.val()) {
                // Value in Searchbox
                if (!this.spinning) {
                    this.searchResults.html('<div class="lds-ripple"><div></div><div></div></div>')
                    this.spinning = true
                }
                this.typingTimer = setTimeout(this.getResults.bind(this), 750);
            } else {
                // Blanked out Searchbox
                this.searchResults.html('')
                this.spinning = false
            }
        }
        this.prevSeachTerm = this.searchBox.val()
    }

    getResults() {
        $.when(
            $.getJSON(dmhData.root_url + '/wp-json/wp/v2/posts?search=' + this.searchBox.val()),
            $.getJSON(dmhData.root_url + '/wp-json/wp/v2/pages?search=' + this.searchBox.val()),
            $.getJSON(dmhData.root_url + '/wp-json/wp/v2/event?search=' + this.searchBox.val()),
            $.getJSON(dmhData.root_url + '/wp-json/wp/v2/angebot?search=' + this.searchBox.val()),
            $.getJSON(dmhData.root_url + '/wp-json/wp/v2/job?search=' + this.searchBox.val()),
            $.getJSON(dmhData.root_url + '/wp-json/wp/v2/person?search=' + this.searchBox.val())
        ).then((posts, pages, events, angebote, jobs, personen) => {
            this.searchResults.html(`                     
                        ${personen[0].length ? '<h2>Kontaktdaten</h2>' : ''}
                        ${personen[0].map(item => `
                        <div class="one-person">
                                <h3>
                                    ${item.acf.vorname} ${item.acf.nachname}</h3>
                                <h4>${item.acf.rolle}</h4>
                                <p class="person-kontakt"><i class="fa-solid fa-envelope"></i> <a
                                            href="mailto:${item.acf.email}">${item.acf.email}</a>
                                </p>
                                <p class="person-kontakt"><i class="fa-solid fa-phone"></i> <a
                                            href="tel:${item.acf.telefon}">${item.acf.telefon}</a>
                                </p>
                            </div>
                        `).join('')}
                        
                        ${jobs[0].length ? '<h2>Stellenausschreibungen</h2>' : ''}
                        ${jobs[0].map(item => `
<div class="one-job">
    <div class="one-job-details">
        <div class="one-job-stelle">
            <a href="${item.link}">
                <h2>${item.title.rendered}</h2>
            </a>
            <p>Pensum: ${item.acf.prozent}<br />
                ${item.acf.stellengruppe}</p>
        </div>
        <div class="one-job-ort">
            <h2 class="job-spacer">&nbsp;</h2>
            <p>${item.acf.dienstort}<br />
                ${item.acf.einrichtung}</p>
        </div>
    </div>
</div>
                        `).join('')}
                        
                        ${events[0].length ? '<h2>Veranstaltungen</h2>' : ''}
                        ${events[0].map(item => `
                        <div class="search-content-event">
                        ${item.customFields.featuredImage ? '<img src="' + item.customFields.featuredImage + '" class="searchResult-image"/>' : ''}
                        <div>
                        <h5><a href="${item.link}">${item.title.rendered}</a></h5>
                        <p class="zeitangabe">${item.customFields.vorbei ? 'Diese Veranstaltung hat bereits stattgefunden.<br />' : ''}
                        ${item.customFields.zeitangabe}</p>
                        ${item.excerpt.rendered}
                        </div>
                        </div>
                        `).join('')}

                        ${posts[0].length ? '<h2>News</h2>' : ''}
                        ${posts[0].map(item => `
                        <div class="search-content-event">
                        ${item.customFields.featuredImage ? '<img src="' + item.customFields.featuredImage + '" class="searchResult-image"/>' : ''}
                        <div>
                        <h5><a href="${item.link}">${item.title.rendered}</a></h5>
                        <p class="zeitangabe">${item.customFields.zeitangabe}</p>
                        ${item.excerpt.rendered}
                        </div>
                        </div>
                        `).join('')}

                        ${angebote[0].length ? '<h2>Angebote und Einrichtungen</h2>' : ''}
                        ${angebote[0].map(item => `
                        <div class="search-content-event">
                        ${item.customFields.featuredImage ? '<img src="' + item.customFields.featuredImage + '" class="searchResult-image"/>' : ''}
                        <div>
                        <h5><a href="${item.link}">${item.title.rendered}</a></h5>
                        ${item.excerpt.rendered}
                        </div>
                        </div>
                        `).join('')}

                        ${pages[0].length ? '<h2>Allgemeine Informationen</h2>' : ''}
                        ${pages[0].map(item => `
                        <div class="search-content-event">
                        ${item.customFields.featuredImage ? '<img src="' + item.customFields.featuredImage + '" class="searchResult-image"/>' : ''}
                        <div>
                        <h5><a href="${item.link}">${item.title.rendered}</a></h5>
                        ${item.excerpt.rendered}
                        </div>
                        </div>
                        `).join('')}

                        ${pages[0].length + posts[0].length + events[0].length + angebote[0] + personen[0].length + jobs[0].length ? '' : '<h4>Kein Resultat für diesen Suchbegriff.</h4>'}
                        <div class="search-content-abstand"></div>
                    `)
        }, () => {
            this.searchResults.html('<p>Leider ist ein Fehler aufgetreten. Bitte überprüfen SIe Ihre Internetverbindung.</p>')
        })
        this.spinning = false;
    }

    keyupDispatcher(e) {
        if (e.keyCode == 27 && this.searchIsOpen) {
            this.closeOverlay()
        }
        if (e.keyCode == 83 && !this.searchIsOpen && !$("input, textarea").is(':focus')) {
            this.openOverlay()
        }
    }

    openOverlay() {
        this.searchIsOpen = true;
        this.searchOverlay.addClass("search-overlay--active")
        $("body").addClass("body-no-scroll")
        this.searchBox.val('')
        setTimeout(() => this.searchBox.focus(), 350);
        this.searchResults.html('')
        this.spinning = false;
    }

    closeOverlay() {
        this.searchIsOpen = false;
        this.searchOverlay.removeClass("search-overlay--active")
        $("body").removeClass("body-no-scroll")
    }

    addSearchOverlay() {
        $("footer").after(`
<div class="search-overlay">
    <div class="search-top">
        <i class="fa fa-search search-overlay--icon"></i>
        <input type="text" class="search-term" id="search-term" autocomplete="off" placeholder="">
        <i class="fa fa-close search-overlay--icon js-search-close"></i>
    </div>
    <div class="search-content" id="search-results">
    </div>
</div>
        `)
    }
}

export default Search
